import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { BOOTSTRAP_FORMLY_CONFIG, FIELD_TYPE_COMPONENTS } from './ui-bootstrap.config';
export class FormlyBootstrapModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: FIELD_TYPE_COMPONENTS,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyModule.forRoot(BOOTSTRAP_FORMLY_CONFIG),
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FormlyBootstrapModule_tsickle_Closure_declarations() {
/** @type {?} */
FormlyBootstrapModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyBootstrapModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
